export function getAddressByPlaceId(placeId, callback) {
  const google = window.google;
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ placeId: placeId }, function(res, status) {
    let result = res[0] && status === "OK" ? res[0].formatted_address : null;
    callback(result);
  });
}
